import { Button, Text } from 'components';
import { useTranslation } from 'react-i18next';

interface PromotionCardProps {
  title: string;
  description: string;
  notice: string;
  imageUrl?: string;
  buttonText?: string;
  buttonLink?: string;
  onJoinClick: () => void;
  'aria-label'?: string;
}

export const PromotionCard = ({ 
  title, 
  description, 
  notice, 
  imageUrl, 
  buttonText, 
  onJoinClick,
  'aria-label': ariaLabel 
}: PromotionCardProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 rounded-3xl bg-white p-4 shadow-sm w-[800px] aspect-[16/9] mx-auto">
      {imageUrl && (
        <img 
          className="w-full aspect-[16/9] object-cover rounded-lg" 
          src={imageUrl} 
          alt={`${title} 프로모션 이미지`}
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.style.display = 'none';
          }}
        />
      )}
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-1">
          <Text size="heading2" weight="medium" color="black">
            {title}
          </Text>
          <Text size="body2" weight="regular" color="description">
            {description}
          </Text>
        </div>
        {/* 버튼이 있는 경우에만 표시 */}
        {(buttonText && buttonText.trim()) && (
          <div className="flex flex-row gap-2">
            <Button 
              className="h-8" 
              text={buttonText} 
              type="blue" 
              size="large" 
              onClick={onJoinClick}
              aria-label={ariaLabel}
            />
          </div>
        )}
        <div className="border-border_primary h-[1px] w-full border-t-[1px]" />
        <div className="flex flex-col gap-2">
          <Text size="body2" weight="regular" color="black">
            {t('promotion.card.noticeTitle')}
          </Text>
          <Text size="body2" weight="regular" color="description">
            {notice}
          </Text>
        </div>
      </div>
    </div>
  );
};